/**
 * @function v3sBorder
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * Transforms textdata of WBTDesigner Elements to textelements 
 */
angular.module('v3sWbtPlayerApp').directive('v3sData', function () {
    return {
        restrict: 'E',
        scope: {
            v3sTextalign: '@',
            v3sVerticalalign: '@',
            v3sPaddingTop: '@',
            v3sPaddingLeft: '@'
        },
        link: function (scope, element, attributes) {

            switch (scope.v3sTextalign) {
                case "center":
                    element.addClass('v3s-align-center');
                    break;
                case "right":
                    element.addClass('v3s-align-right');
                    break;
                case "left":
                    element.addClass('v3s-align-left');
                    break;
            }

            switch (scope.v3sVerticalalign) {
                case "middle":
                    element.addClass('v3s-align-middle');
                    break;
                case "bottom":
                    element.addClass('v3s-align-bottom')
                    break;
                case "top":
                    element.addClass('v3s-align-top');
                    break;
            }

            if (!!scope.v3sPaddingTop) {
                element.css("padding-top", scope.v3sPaddingTop + "px");
            }

            if (!!scope.v3sPaddingLeft) {
                element.css("padding-left", scope.v3sPaddingLeft + "px");
            }

        }
    }
});